import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export default axios.create({
  baseURL: BASE_URL,
});

const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json", "env": "test" },
  withCredentials: true,
});

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_PATH = "/admin";
const VENDOR_PATH = "vendor";
const IMAGE_PATH = "uploadImage";

const AUTH_API_URL = {
  login: path(VENDOR_PATH, "/login"),
  updatePushTokenNotification: path(VENDOR_PATH, "/updatePushTokenNotification"),
  register: path(VENDOR_PATH, "/register"),
  verifyOtp: path(VENDOR_PATH, "/verifyOtp"),
  getProfile: path(VENDOR_PATH, "/getProfile"),
  editProfile: path(VENDOR_PATH, "/editProfile/"),
  changePassword: path(VENDOR_PATH, "/changePassword/"),
  getOtp: path(VENDOR_PATH, "/get/otp"),
  forgotVerifyOtp: path(VENDOR_PATH, "/verify/Otp"),
  forgotPassword: path(VENDOR_PATH, "/forgotpassword"),
  resendOTP: path(VENDOR_PATH, "/otp/resend"),
  logout: path(VENDOR_PATH, "/logout"),
  uploadImage: path(IMAGE_PATH, "/vendorKYC"),
  uploadMainImage: path(IMAGE_PATH, "/vendor"),
  twoFactorVerification: path(VENDOR_PATH, "/verify/TwoFactorAuth"),
  resendTwoFactorOtp: path(VENDOR_PATH, "/verify/twoFactor/resend"),
  uploadKyc: path(VENDOR_PATH, "/addKyc"),
  addBank: path(VENDOR_PATH, "/addBank"),

  // get sub category on category change
  getSubCategory: path(VENDOR_PATH, "/register/getSubcategories"),
  // ====================== no use ===================
  refreshToken: path(ROOTS_PATH, "/refreshToken"),
};

const FOOD_ITEMS = {
  getFood: path(VENDOR_PATH, "/getFoodItem"),
  addFood: path(VENDOR_PATH, "/foodItemAdd"),
  editFood: path(VENDOR_PATH, "/foodItemUpdate/"),
  deleteFood: path(VENDOR_PATH, "/deleteFoodItem/"),
  getFoodCategory: path(VENDOR_PATH, "/getFoodCategory"),
  getFoodCategoryList: path(VENDOR_PATH, "/foodCategory"),
  uploadImage: path(IMAGE_PATH, "/foodItem"),
  changeFoodItemStatus: path(VENDOR_PATH, "/foodItemInactive/"),
  // vendor/groceryCategory,vendor/foodCategory

  getFoodMenu: path(VENDOR_PATH, "/getFoodMenu"),
  getFoodMenuData: path(VENDOR_PATH, "/foodMenu"),
  addFoodMenu: path(VENDOR_PATH, "/foodMenuAdd"),
  editFoodMenu: path(VENDOR_PATH, "/foodMenuUpdate/"),
  deleteFoodMenu: path(VENDOR_PATH, "/deleteFoodMenu/"),
  changeStatus: path(VENDOR_PATH, "/foodMenuInactive/"),
}

const GROCERY_ITEM = {
  getGoceryItems: path(VENDOR_PATH, "/getGroceryItem"),
  getGroceryCategory: path(VENDOR_PATH, "/getGroceryCategory"),
  getGroceryCategoryList: path(VENDOR_PATH, "/groceryCategory"),
  addGrocery: path(VENDOR_PATH, "/groceryItemAdd"),
  updateGrocery: path(VENDOR_PATH, "/groceryItemUpdate/"),
  deleteGrocery: path(VENDOR_PATH, "/deleteGroceryItem/"),
  uploadImage: path(IMAGE_PATH, "/groceryItem"),
  changeGroceryItemStatus: path(VENDOR_PATH, "/groceryItemInactive/"),

  getGrocerymenu: path(VENDOR_PATH, "/getGroceryMenu"),
  getGrocerymenuList: path(VENDOR_PATH, "/grocerymenu"),
  addGroceryMenu: path(VENDOR_PATH, "/groceryMenuAdd"),
  editGroceryMenu: path(VENDOR_PATH, "/groceryMenuUpdate/"),
  deleteGroceryMenu: path(VENDOR_PATH, "/deleteGroceryMenu/"),
  changeStatus: path(VENDOR_PATH, "/inactiveGroceryMenu/"),
}

const EVENTS = {
  getEvents: path(VENDOR_PATH, "/getEvent"),
  uploadImage: path(IMAGE_PATH, "/eventImage"),
  uploadticketImage: path(IMAGE_PATH, "/tickets"),
  addEvent: path(VENDOR_PATH, "/addEvent"),
  changeEventStatus: path(VENDOR_PATH, "/eventInactive"),
  deleteEvent: path(VENDOR_PATH, "/deleteEvent"),
  eventUpdate: path(VENDOR_PATH, "/updateEvent"),
  getbookedList: path(VENDOR_PATH, "/bookedEventList"),
  sendTicket: path(VENDOR_PATH, "/sendTicketToUser"),
}

const TRAVELS = {
  getTravel: path(VENDOR_PATH, "/getTravel"),
  uploadImage: path(IMAGE_PATH, "/travelmenu"),
  travelAdd: path(VENDOR_PATH, "/addTravel"),
  changeTravelStatus: path(VENDOR_PATH, "/travelInactive"),
  deleteTravel: path(VENDOR_PATH, "/deleteTravel"),
  updateTravel: path(VENDOR_PATH, "/updateTravel"),
}
const ADVERTISEMENT = {
  getAdvertisment: path(VENDOR_PATH, "/getAdvertise"),
  uploadImage: path(IMAGE_PATH, "/advertisement"),
  addAdvertisment: path(VENDOR_PATH, "/advertisementAdd"),
  changeStatus: path(VENDOR_PATH, "/AdsRequestStatusChange"),
  advertisementDelete: path(VENDOR_PATH, "/advertisementDelete"),
  advertisementUpdate: path(VENDOR_PATH, "/advertisementUpdate"),
}

const NGO = {
  getNgo: path(VENDOR_PATH, "/getNgo"),
  uploadImage: path(IMAGE_PATH, "/ngoItems"),
  ngoAdd: path(VENDOR_PATH, "/addNgo"),
  changeStatus: path(VENDOR_PATH, "/ngoInactive"),
  deleteNgo: path(VENDOR_PATH, "/deleteNgo"),
  ngoUpdate: path(VENDOR_PATH, "/updateNgo"),
  getCharityTransactionList: path(VENDOR_PATH, "/charityTransaction"),
}

const VENDOR_API_URL = {
  getSubVendor: path(VENDOR_PATH, "/getSubVendor"),
  addSubVendor: path(VENDOR_PATH, "/addSubVendor"),
  editSubVendor: path(VENDOR_PATH, "/updateSubVendor/"),
  deleteSubVendor: path(VENDOR_PATH, "/deleteSubVendor/"),
  uploadImage: path(IMAGE_PATH, "/vendor"),
  changeStatus: path(VENDOR_PATH, "/subVendorStatus/"),
  getOrdersCount: path(VENDOR_PATH, "/orderCount"),
  vendorDashboard: path(VENDOR_PATH, "/dashboard"),

  // getVendorList: path(ROOTS_PATH, "/listVendor"),
  // vendorAdd: path(ROOTS_PATH, "/addVendor"),
  // vendorInactive: path(ROOTS_PATH, "/vendorInactive/"),
  // vendorVerify: path(ROOTS_PATH, "/vendorVerify/"),
  // vendorUpdate: path(ROOTS_PATH, "/updateVendor/"),
  // vendorDelete: path(ROOTS_PATH, "/deleteVendor/"),
  // addMainCategory: path(ROOTS_PATH, "/mainCategoryAdd"),
  // updateMainCategory: path(ROOTS_PATH, "/mainCategoryUpdate/"),
  // deleteMainCategory: path(ROOTS_PATH, "/deleteMainCategory"),
  // uploadImage: path("/", "uploadImage/"),
}

const PERMISSION_API_URL = {
  getPermissionList: path(VENDOR_PATH, "/getVendorPermission/"),
  updateStatus: path(VENDOR_PATH, "/vendorRoleStatus/"),
}

const ROLE_API_URL = {
  getRoleList: path(VENDOR_PATH, "/getVendorRole"),
  addRole: path(VENDOR_PATH, "/vendorRoleAdd"),
  updateRole: path(VENDOR_PATH, "/vendorRoleUpdate/"),
  editRole: path(VENDOR_PATH, "/vendorRoleEdit"),
  deleteRole: path(VENDOR_PATH, "/deleteVendorRole/"),
  getVendorRole: path(VENDOR_PATH, "/getVendorRoles")
}

const ORDERS = {
  getOrder: path(VENDOR_PATH, "/getOrder"),
  deleteOrder: path(VENDOR_PATH, "/deleteOrder/"),
  getOrderById: path(VENDOR_PATH, "/order/getOrderById"),
  changeOrderStatus: path(VENDOR_PATH, "/order/changeOrderStatus"),
  deletePendingOrder: path(VENDOR_PATH, "/order/deletePendingOrder/"),
  disputedOrder: path(VENDOR_PATH, "/order/getDesputedOrder"),
  getVendorDisputedOrder: path(VENDOR_PATH, "/getVendorDisputedOrder"),
  deleteDisputedOrder: path(VENDOR_PATH, "/order/deleteDisputeOrder/")
}

const PAYOUT = {
  getMyPayout: path(VENDOR_PATH, "/myPayout"),
  getPendingPayout: path(VENDOR_PATH, "/payout/getPeningPayout"),
  getCompletedPayout: path(VENDOR_PATH, "/payout/getCompletedPayout"),
  getTransactionList: path(VENDOR_PATH, "/transactionList"),
  getOrders: path(VENDOR_PATH, "/myOrders/")
}

const SUPPORT = {
  getSupportRequest: path(VENDOR_PATH, "/getVendorSendSupportRequest"),
  deleteSupportRequest: path(VENDOR_PATH, "/deleteSupportTicket/"),
  addSupportRequest: path(VENDOR_PATH, "/sendSupportRequest"),
  updateSupportRequest: path(VENDOR_PATH, "/updateSupportTicketList/"),
  getFeedback: path(VENDOR_PATH, "/getFeedback"),
  replyFeedback: path(VENDOR_PATH, "/feedbackReply/"),
  getSupportSubject: path(VENDOR_PATH, "/getSupportSubject"),
  getChatMessage: path(VENDOR_PATH, "/getChatMessage"),
  sendMessage: path(VENDOR_PATH, "/sendMessage")
}

const SETTING = {
  enableTwoFactor: path(VENDOR_PATH, "/twoFactAuth/")
}

const CATEGORY_API_URL = {
  changeGroceryCategoryStatus: path(VENDOR_PATH, "/inactiveGroceryCategory/"),
  changeFoodCategoryStatus: path(VENDOR_PATH, "/editStatusFoodCategory/"),
}

export {
  axiosPrivate,
  AUTH_API_URL,
  FOOD_ITEMS,
  GROCERY_ITEM,
  PERMISSION_API_URL,
  CATEGORY_API_URL,
  ROLE_API_URL,
  ORDERS,
  PAYOUT,
  SUPPORT,
  VENDOR_API_URL,
  EVENTS,
  TRAVELS,
  NGO,
  SETTING,
  ADVERTISEMENT
}